/**
 * @generated SignedSource<<3a2587a8feb5ed65f63719a9f78f154d>>
 * @relayHash e4b9571054871d36ce4a62f8dfc3a347
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 460e3bc3e7ed3d8d27b904af0f9749ba9913444eb0c65d55e5522990c53522ff

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type setMostRecentlyViewedBoardMutation$variables = {
  id: string;
};
export type setMostRecentlyViewedBoardMutation$data = {
  readonly jira: {
    readonly setMostRecentlyViewedBoard: {
      readonly board: {
        readonly id: string;
      } | null | undefined;
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type setMostRecentlyViewedBoardMutation = {
  response: setMostRecentlyViewedBoardMutation$data;
  variables: setMostRecentlyViewedBoardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "ScalarField",
    "name": "id"
  }
],
v3 = {
  "concreteType": "JiraBoard",
  "kind": "LinkedField",
  "name": "board",
  "plural": false,
  "selections": (v2/*: any*/)
},
v4 = {
  "kind": "ScalarField",
  "name": "success"
},
v5 = {
  "kind": "ScalarField",
  "name": "message"
},
v6 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "setMostRecentlyViewedBoardMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSetMostRecentlyViewedBoardPayload",
            "kind": "LinkedField",
            "name": "setMostRecentlyViewedBoard",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "setMostRecentlyViewedBoardMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSetMostRecentlyViewedBoardPayload",
            "kind": "LinkedField",
            "name": "setMostRecentlyViewedBoard",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v2/*: any*/),
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "460e3bc3e7ed3d8d27b904af0f9749ba9913444eb0c65d55e5522990c53522ff",
    "metadata": {},
    "name": "setMostRecentlyViewedBoardMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "4cedd313a6b84b6c272b36ea0fb2a5e6";

export default node;
